import classNames from 'classnames';
import React from 'react';
import CloseSvg from 'images/v5/icons/x-close.svg';
import styles from './Tag.module.scss';
function Tag({ label, onRemove, disabled = false, className }) {
    return (React.createElement("span", { className: classNames(styles.tag, { [styles.disabled]: disabled }, className) },
        React.createElement("span", { className: styles.label }, label),
        onRemove && (React.createElement("button", { type: "button", className: styles.removeButton, onClick: (e) => {
                e.stopPropagation();
                onRemove === null || onRemove === void 0 ? void 0 : onRemove();
            }, disabled: disabled, tabIndex: -1 },
            React.createElement(CloseSvg, null)))));
}
export default Tag;
